var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from "mobx";
import { endOfDay, format, startOfDay, startOfMonth, subDays } from "date-fns";
import { MAX_NEW_PATIENT_RANGE_DAYS } from "healthex-common/analytics.dtos";
export class GlobalAdminAnalyticsViewModel {
    constructor(container) {
        this.startDate = startOfMonth(new Date());
        this.endDate = endOfDay(new Date());
        this.analyticsManager = container.globalAdminAnalyticsManager;
    }
    get countResult() {
        return this.analyticsManager.newPatientCount;
    }
    get isLoading() {
        return this.analyticsManager.isLoadingCount;
    }
    get errorMessage() {
        return this.analyticsManager.errorMessage;
    }
    get dateRangeValid() {
        return this.dateRangeError === null;
    }
    get dateRangeError() {
        if (this.endDate < this.startDate) {
            return "End date must be after start date";
        }
        if (this.endDate.getTime() > endOfDay(new Date()).getTime()) {
            return "End date cannot be in the future";
        }
        const diffDays = (this.endDate.getTime() - this.startDate.getTime()) / (1000 * 60 * 60 * 24);
        if (diffDays > MAX_NEW_PATIENT_RANGE_DAYS) {
            return `Date range cannot exceed ${MAX_NEW_PATIENT_RANGE_DAYS} days`;
        }
        return null;
    }
    get canLoadData() {
        return this.dateRangeValid;
    }
    setStartDate(date) {
        this.startDate = startOfDay(date);
    }
    setEndDate(date) {
        this.endDate = endOfDay(date);
    }
    async loadData() {
        if (!this.dateRangeValid) {
            return;
        }
        await this.analyticsManager.loadNewPatientCount({
            startDate: this.startDate,
            endDate: this.endDate,
        });
    }
    formatDate(date) {
        return format(date, "MMM d, yyyy");
    }
    formatDateRange() {
        return `${this.formatDate(this.startDate)} - ${this.formatDate(this.endDate)}`;
    }
    async setToday() {
        const now = new Date();
        this.startDate = startOfDay(now);
        this.endDate = endOfDay(now);
        await this.loadData();
    }
    async setYesterday() {
        const yesterday = subDays(new Date(), 1);
        this.startDate = startOfDay(yesterday);
        this.endDate = endOfDay(yesterday);
        await this.loadData();
    }
    async setLast7Days() {
        const now = new Date();
        this.startDate = startOfDay(subDays(now, 7));
        this.endDate = endOfDay(now);
        await this.loadData();
    }
    async setLast30Days() {
        const now = new Date();
        this.startDate = startOfDay(subDays(now, 30));
        this.endDate = endOfDay(now);
        await this.loadData();
    }
}
__decorate([
    observable
], GlobalAdminAnalyticsViewModel.prototype, "startDate", void 0);
__decorate([
    observable
], GlobalAdminAnalyticsViewModel.prototype, "endDate", void 0);
__decorate([
    computed
], GlobalAdminAnalyticsViewModel.prototype, "countResult", null);
__decorate([
    computed
], GlobalAdminAnalyticsViewModel.prototype, "isLoading", null);
__decorate([
    computed
], GlobalAdminAnalyticsViewModel.prototype, "errorMessage", null);
__decorate([
    computed
], GlobalAdminAnalyticsViewModel.prototype, "dateRangeValid", null);
__decorate([
    computed
], GlobalAdminAnalyticsViewModel.prototype, "dateRangeError", null);
__decorate([
    computed
], GlobalAdminAnalyticsViewModel.prototype, "canLoadData", null);
__decorate([
    action
], GlobalAdminAnalyticsViewModel.prototype, "setStartDate", null);
__decorate([
    action
], GlobalAdminAnalyticsViewModel.prototype, "setEndDate", null);
__decorate([
    action
], GlobalAdminAnalyticsViewModel.prototype, "loadData", null);
__decorate([
    action
], GlobalAdminAnalyticsViewModel.prototype, "setToday", null);
__decorate([
    action
], GlobalAdminAnalyticsViewModel.prototype, "setYesterday", null);
__decorate([
    action
], GlobalAdminAnalyticsViewModel.prototype, "setLast7Days", null);
__decorate([
    action
], GlobalAdminAnalyticsViewModel.prototype, "setLast30Days", null);
